import { array, string, struct } from 'io-ts/lib/Decoder';

import { EqualsType } from '../../api/generic/search/filter';

/** Multi-select filter on the whole-house sub-ancillary takeoffs a transaction
 *  contains. Values are sub-ancillary item ids; a row matches when its
 *  sub-ancillary set contains any of them. Sub-ancillaries are not priced but
 *  are exposed for slicing the report. */
export const SubAncillaryItems = struct({
	equalsType: EqualsType,
	values: array(string),
});
